export class Log {

    message: string;
    statusCode: number;
  
    constructor (obj? : any) {
        this.message = obj?.message;
        this.statusCode = obj?.statusCode;
    }
  }